/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import { convertHexToRGBA } from 'utils/convertHexToRgba';
import { useCart } from 'hooks/useCart';

const Rolling = ({ color }) => {
  return (
    <svg
      className="lds-spin"
      width="100"
      height="100"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      color={color}
    >
      <g transform="translate(80,50)">
        <g transform="rotate(0)">
          <circle
            cx="0"
            cy="0"
            r="7"
            fill="currentColor"
            fillOpacity="1"
            transform="scale(1.03426 1.03426)"
          >
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.875s"
              values="1.1 1.1;1 1"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
            ></animateTransform>
            <animate
              attributeName="fill-opacity"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
              values="1;0"
              begin="-0.875s"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(71.21320343559643,71.21320343559643)">
        <g transform="rotate(45)">
          <circle
            cx="0"
            cy="0"
            r="7"
            fill="currentColor"
            fillOpacity="0.875"
            transform="scale(1.04676 1.04676)"
          >
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.75s"
              values="1.1 1.1;1 1"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
            ></animateTransform>
            <animate
              attributeName="fill-opacity"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
              values="1;0"
              begin="-0.75s"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(50,80)">
        <g transform="rotate(90)">
          <circle
            cx="0"
            cy="0"
            r="7"
            fill="currentColor"
            fillOpacity="0.75"
            transform="scale(1.05926 1.05926)"
          >
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.625s"
              values="1.1 1.1;1 1"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
            ></animateTransform>
            <animate
              attributeName="fill-opacity"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
              values="1;0"
              begin="-0.625s"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(28.786796564403577,71.21320343559643)">
        <g transform="rotate(135)">
          <circle
            cx="0"
            cy="0"
            r="7"
            fill="currentColor"
            fillOpacity="0.625"
            transform="scale(1.07176 1.07176)"
          >
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.5s"
              values="1.1 1.1;1 1"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
            ></animateTransform>
            <animate
              attributeName="fill-opacity"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
              values="1;0"
              begin="-0.5s"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(20,50.00000000000001)">
        <g transform="rotate(180)">
          <circle
            cx="0"
            cy="0"
            r="7"
            fill="currentColor"
            fillOpacity="0.5"
            transform="scale(1.08426 1.08426)"
          >
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.375s"
              values="1.1 1.1;1 1"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
            ></animateTransform>
            <animate
              attributeName="fill-opacity"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
              values="1;0"
              begin="-0.375s"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(28.78679656440357,28.786796564403577)">
        <g transform="rotate(225)">
          <circle
            cx="0"
            cy="0"
            r="7"
            fill="currentColor"
            fillOpacity="0.375"
            transform="scale(1.09676 1.09676)"
          >
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.25s"
              values="1.1 1.1;1 1"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
            ></animateTransform>
            <animate
              attributeName="fill-opacity"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
              values="1;0"
              begin="-0.25s"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(49.99999999999999,20)">
        <g transform="rotate(270)">
          <circle
            cx="0"
            cy="0"
            r="7"
            fill="currentColor"
            fillOpacity="0.25"
            transform="scale(1.00926 1.00926)"
          >
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.125s"
              values="1.1 1.1;1 1"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
            ></animateTransform>
            <animate
              attributeName="fill-opacity"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
              values="1;0"
              begin="-0.125s"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(71.21320343559643,28.78679656440357)">
        <g transform="rotate(315)">
          <circle
            cx="0"
            cy="0"
            r="7"
            fill="currentColor"
            fillOpacity="0.125"
            transform="scale(1.02176 1.02176)"
          >
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="0s"
              values="1.1 1.1;1 1"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
            ></animateTransform>
            <animate
              attributeName="fill-opacity"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
              values="1;0"
              begin="0s"
            ></animate>
          </circle>
        </g>
      </g>
    </svg>
  );
};

const Loading = ({ fixed }) => {
  const {
    productTheme: { color },
  } = useCart();

  const backgroundColor = convertHexToRGBA(color.primary.pure, 0.8);

  return (
    <div
      id="loading"
      className={`
        flex items-center justify-center
        ${fixed ? 'fixed inset-0 w-full h-full z-[15] cursor-default' : ''}`}
      style={{ backgroundColor }}
    >
      <Rolling color={color.secondary.pure} />
    </div>
  );
};

Loading.defaultProps = {
  fixed: true,
  isUpsell: false,
};
Loading.propTypes = {
  fixed: PropTypes.bool,
  isUpsell: PropTypes.bool,
};

export default Loading;
